import { useState } from "react";
import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import Typography from "@mui/material/Typography";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import Alert from "@mui/material/Alert";
import { useLocation, useNavigate } from "react-router-dom";
import Wordmark from "../components/Wordmark";
import SectionLabel from "../components/SectionLabel";
import { useAuth } from "../context/AuthContext";
import { tokens } from "../theme";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const location = useLocation() as { state?: { from?: string } };
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState(false);

  const submit = async () => {
    if (await login(username, password)) {
      navigate(location.state?.from ?? "/admin", { replace: true });
    } else {
      setError(true);
    }
  };

  return (
    <Container
      maxWidth="xs"
      sx={{
        minHeight: "calc(100vh - 200px)",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        py: 8,
      }}
    >
      <Box sx={{ textAlign: "center", mb: 4 }}>
        <Wordmark size={34} />
      </Box>
      <Box
        sx={{
          bgcolor: tokens.paper,
          border: `1px solid ${tokens.line}`,
          p: { xs: 3, sm: 4.5 },
          boxShadow: "0 18px 50px rgba(27,26,23,0.08)",
        }}
      >
        <SectionLabel align="center">Studio access</SectionLabel>
        <Typography
          variant="h3"
          sx={{ mt: 1.5, mb: 3, textAlign: "center", fontSize: "2rem" }}
        >
          Sign in
        </Typography>

        {error && (
          <Alert
            severity="error"
            sx={{ mb: 2.5, borderRadius: 1 }}
            onClose={() => setError(false)}
          >
            That username and password did not match.
          </Alert>
        )}

        <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
          <TextField
            label="Username"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            onKeyDown={(e) => e.key === "Enter" && submit()}
            autoFocus
            fullWidth
          />
          <TextField
            label="Password"
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            onKeyDown={(e) => e.key === "Enter" && submit()}
            fullWidth
          />
          <Button
            onClick={submit}
            variant="contained"
            color="primary"
            fullWidth
            sx={{ mt: 1, py: 1.3 }}
          >
            Enter the studio
          </Button>
        </Box>

        <Typography
          sx={{
            mt: 3,
            textAlign: "center",
            fontSize: "0.78rem",
            color: tokens.taupe,
          }}
        >
          This area is private. Accounts are by invitation only.
        </Typography>
      </Box>
    </Container>
  );
}
